export default __webpack_public_path__ + "static/media/click.74165dd3.png";